import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import './defaultCountry.css'
import togoImage from "../../../src/images/togoMapEdit.svg"
import useravatar from "../../images/userAvatar.svg"
import ReactStars from "react-rating-stars-component"
import { motion, AnimatePresence } from 'framer-motion';
import { SlArrowLeft, SlArrowRight  } from "react-icons/sl";

//import { GoogleLogin, googleLogout, GoogleLogout } from '@react-oauth/google';
import { useGoogleLogin, googleLogout } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom'
import { jwtDecode} from 'jwt-decode'
import LoginModal from '../../ass_overlay_components/LoginModal'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
export const regionList = [
  {
    name: 'SAVANE',
    detail: `This region is named SAVANE and contains 5 provinces: Cinkassé, Dapaong (the main city in the region), Mandouri, Tandjouare, Mango.`,
    color: '#35b783',
    totalP: 235,
    educatedP: 'Mil',
    provinces: [
      {
        
        name: 'Cinkasse',
        totalP: 351,
        educatedP: 'Sorgho',
        isCity: false,
      },
      {
        name: 'Dapaong',
        totalP: 351,
        educatedP: 'fonio',
        isCity: true,
      },
      {
        name: 'Mandouri',
        totalP: 351,
        educatedP: 'Mil',
        isCity: false,
      },
      {
        name: 'Tandjouare',
        totalP: 351,
        educatedP: 'Fonio',
        isCity: false,
      },
      {
        name: 'Mango',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      }
    ]
  },
  {
    name: 'KARA-OUEST',
    detail: `This region is named KARA-OUEST and contains 3 provinces: Guerinkouka, Bassar (the main city in the region), and djarkpanga.`,
    color: '#e907df',
    totalP: 455,
    educatedP: 'Mil',
    provinces: [
      {
        name: 'Guerin Kouka',
        totalP: 351,
        educatedP: 'Mil',
        isCity: false,
      },
      {
        name: 'Bassar',
        totalP: 351,
        educatedP: 'Igname',
        isCity: true,
      },
      {
        name: 'Djarkpanga',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
    ]
  },
  {
    name: 'KARA-EST',
    detail: `This region is named KARA-EST and contains 5 provinces: Kante, Niamtougou, Pagouda, Kara (the main city in the region), and Bafilo.`,
    color: '#ac1d26',
    totalP: 635,
    educatedP: 'Mil',
    provinces: [
      {
        name: 'Kante',
        totalP: 351,
        educatedP: 'Sorgho',
        isCity: false,
      },
      {
        name: 'Niamtougou',
        totalP: 351,
        educatedP: 'Legumes',
        isCity: false,
      },
      {
        name: 'Pagouda',
        totalP: 351,
        educatedP: 'Fonio',
        isCity: false,
      },
      {
        name: 'Kara',
        totalP: 351,
        educatedP: 'Mil',
        isCity: true,
      },
      {
        name: 'Bafilo',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
    ]
  },
  {
    name: 'CENTRALE',
    detail: `This region is named CENTRALE and contains 4 provinces: Sokode(the main city in the region), Tchamba, Sotouboua and Blitta.`,
    color: '#cdcf62',
    totalP: 515,
    educatedP: 'Maïs',
    provinces: [
      {
        name: 'Sokode',
        totalP: 351,
        educatedP: 'Mil',
        isCity: true,
      },
      {
        name: 'Tchamba',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Sotouboua',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Blitta',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
    ]
  },
  {
    name: 'PLATEAU-OUEST',
    detail: `This region is named PLATEAU-OUEST and contains 7 provinces: Kounyowou, Badou, Amlamé, Danyi -Apeyeme, Kpélé-Akata, Kpalimé (the main city in the region), and Gadzepé.`,
    color: '#ffa5a5',
    totalP: 852,
    educatedP: 'Igname, Maïs, Soja, Coton',
    provinces: [
      {
        name: 'Kounyowou',
        totalP: 351,
        educatedP: 'Plantin, Cacao',
        isCity: false,
      },
      {
        name: 'Badou',
        totalP: 351,
        educatedP: 'Haricots',
        isCity: false,
      },
      {
        name: 'Amlame',
        totalP: 351,
        educatedP: 'Igname, haricots',
        isCity: false,
      },
      {
        name: 'Danyi-Apeyeme',
        totalP: 351,
        educatedP: 'Igname, Patate',
        isCity: false,
      },
      {
        name: 'Kpele-Akata',
        totalP: 351,
        educatedP: 'Maïs, Igname',
        isCity: false,
      },
      {
        name: 'Kpalime',
        totalP: 351,
        educatedP: 'Igname, Haricot',
        isCity: true,
      },
      {
        name: 'Gadzepe',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
    ]
  },
  {
    name: 'PLATEAU-EST',
    detail: `This region is named PLATEAU-EST and contains 5 provinces: Elavagnon, Anié, Atapkamé (the main city in the region), Tohoun and Notsè.`,
    color: '#11bcb3',
    totalP: 712,
    educatedP: 'Plantin',
    provinces: [
      {
        name: 'Elavagnon',
        totalP: 351,
        educatedP: 'Tubercules',
        isCity: false,
      },
      {
        name: 'Anie',
        totalP: 351,
        educatedP: 'Maïs, Igname, Coton',
        isCity: false,
      },
      {
        name: 'Atapkame',
        totalP: 351,
        educatedP: 'Igname, Maïs, Manioc, Coton',
        isCity: true,
      },
      {
        name: 'Tohoun',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Notse',
        totalP: 351,
        educatedP: 'Maïs, Igname',
        isCity: false,
      },
    ]
  },
  {
    name: 'MARITIME',
    detail: `This region is named Maritime and contains 7 provinces: Kévé, Tsevié, Tabligbo, Lomé (the main city in the region), Vogan, Afagnan and Aného.`,
    color: '#867740',
    totalP: 592,
    educatedP: 'Maïs',
    provinces: [
      {
        name: 'Keve',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Tsevie',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Tabligbo',
        totalP: 351,
        educatedP: 'Manioc, Maïs',
        isCity: false,
      },
      {
        name: 'Lome',
        totalP: 351,
        educatedP: 'Legumes',
        isCity: true,
      },
      {
        name: 'Vogan',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Afagnan',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
      {
        name: 'Aneho',
        totalP: 351,
        educatedP: 'Maïs',
        isCity: false,
      },
    ]
  }
];

// Juste avant le return dans AvailableProducers
const getIncitativeMessage = (culture) => {
  switch (culture.toLowerCase()) {
    case "maïs":
      return "Producteur prêt pour le maïs – Semez en mai, récoltez en août !";
    case "mil":
      return "Excellent choix pour le mil – Cultivez en juin, récoltez en septembre.";
    case "fonio":
      return "Opportunité rare pour le fonio – Plantation en juillet, récolte rapide en octobre.";
    case "igname":
      return "Engagez ce producteur pour l’igname – Période idéale : mars à août.";
    default:
      return "Ce producteur est disponible pour un contrat sécurisé dès maintenant.";
  }
};

const centerReviews = [
  {
    detail: 'Commercial Center',
    type: 'Cacao',
    starNum: 4,
  },
  {
    detail: 'Agro center',
    type: 'Coton',
    starNum: 5,
  }
]

const DefaultCountry = () => {

  // Fetch current country based on IP
  const actualCountry = useSelector((state) => state.country);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedId, setSelectedId] = useState(0);
  const [selectedProvinceId, setSelectedProvinceId] = useState(0);
  const provinces = {
    st0: 'Savanes',
    st1: 'Kara',
    st2: 'Centre',
    st3: 'Plateaux',
    st4: 'Maritime'
  }
  const [currentPage, setCurrentPage] = useState(0);
  const pageNum = 5;
  const [totalPage, setTotalPage] = useState(0);
  const [currentReviews, setCurrentReviews] = useState([]);
  
  useEffect(() => {
    const totalLength = centerReviews.length;
    setTotalPage(Math.ceil(totalLength / pageNum));
    setCurrentPage(1);
    const tmpReviews = centerReviews.slice(0, pageNum * 1);
    setCurrentReviews(tmpReviews);

  }, [])

  const prevPage = () => {
    if(currentPage > 1){
      const tmpCTPage = currentPage - 1;
      const startIndex = (tmpCTPage - 1) * pageNum;
      const tmpReviews = centerReviews.slice(startIndex, pageNum * tmpCTPage);
      setCurrentReviews(tmpReviews);
      setCurrentPage(tmpCTPage);
    }
  }
  const nextPage = () => {
    if(currentPage < totalPage){
      const tmpCTPage = currentPage + 1;
      const startIndex = currentPage * pageNum;
      const tmpReviews = centerReviews.slice(startIndex, pageNum * tmpCTPage);
      setCurrentReviews(tmpReviews);
      setCurrentPage(tmpCTPage);
    }
  }
  
  const [selectedItem, setSelectedItem] = useState(null);

  const regionHover = (regId) => {

    setSelectedRegion(regionList[(regId - 1)]);
    setSelectedId(regId);
  }
  const provinceHover = (regionId, provinceName, provinceId) => {

    const regionData = regionList[(regionId - 1)];
    setSelectedRegion(regionData)
    setSelectedId(regionId);
    setSelectedProvince(regionData.provinces[(provinceId - 1)])
    setSelectedProvinceId(provinceId)
  }
// =================================================================
  const [isOpen, setIsOpen] = useState(false);

  const login = useGoogleLogin({
    onSuccess: credentialResponse => {

      setIsOpen(false); // close modal after login success
    },
    onError: () => {
      console.log('Login Failed');
    }
  });

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <section className="assiganto-home-wrapper-1 py-4">
        <div className="w-full mx-auto px-4">
          <div className="row justify-content-center flex-xl-row flex-lg-row flex-md-row flex-column-reverse">
            <div className="col-xl-6 col-md-6 col-sm-12">
              <h3 className="py-8 text-center">{actualCountry.country} : Les Cultures Tendantielles</h3>
              <div className="region-details">
                <div className="d-flex align-items-center gap-10 my-2">
                  <h3 className="product-heading">Region :</h3>
                  {selectedRegion && 
                    <p className="product-data">{selectedRegion.name}</p>
                  }
                </div>
                <div className="d-flex align-items-center gap-10 my-2">
                  <h3 className="product-heading">Province :</h3>
                  {selectedProvince && 
                    <p className="product-data">{selectedProvince.name}</p>
                  }
                </div>
                <div className="d-flex align-items-center gap-10 my-2">
                  <h3 className="product-heading">Total population :</h3>
                  {selectedProvince && 
                    <p className="product-data">{selectedProvince.totalP}</p>
                  }
                </div>
                <div className="d-flex align-items-center gap-10 my-2">
                  <h3 className="product-heading">Culture dominante :</h3>
                  {selectedProvince &&
                    <p className="product-data">{selectedProvince.educatedP}</p>
                  }
                </div>
              </div>
              
              <AnimatePresence>
                {selectedItem && (
                  <motion.div
                    className="selected-item-details mt-4 p-3 border"
                    key={selectedItem.detail} // Key helps trigger animation on change
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <center><h5>Détails du Producteur Sélectionné</h5></center>
                    <p><strong>Détail:</strong> {selectedItem.detail}</p>
                    <p><strong>Filières:</strong> {selectedItem.type}</p>
                    <p><strong>Étoiles:</strong> {selectedItem.starNum}</p>

                    <div className="center-feedback">
                                        <h5 className="text-center">JOINDRE LE PRODUCTEUR</h5>
                                        <div className="center-feedback-input">
                                          <textarea className="form-control" rows={4} placeholder="Votre message ici"/>
                                        </div>
                                        <div className="center-feedback-phones mt-3">
                                          <div className="border py-1 px-2 mr-2" >
                                            votre contact :
                                          </div>
                                          <div className="mx-2">
                                            <PhoneInput  />
                                          </div>
                                          <div>
                                            <button
                                              className="btn btn-success mx-2"
                                              onClick={openModal}
                                            >
                                              Envoyer
                                            </button>
                                            {isOpen && (<LoginModal triggered='true' />)}
                                          </div>
                                        </div>
                    </div>
                    <button
                      className="btn btn-primary mt-2"
                      onClick={() => setSelectedItem(null)}
                    >
                      Annuler
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
              <div className="all-Centers">
                <h4 className="text-center mt-3">Les Producteurs</h4>

                {currentReviews.map((centerItem, key) => (
                  <div
                  className={`card center-item p-3 ${selectedItem === centerItem ? 'selected' : ''}`}
                  key={key}
                  onClick={() =>
                    setSelectedItem(
                      selectedItem === centerItem ? null : centerItem
                    )
                  }
                  style={{ cursor: 'pointer' }}
                  >
                    <div className="center-avata border">
                      <img src={useravatar} width={100} />
                    </div>
                    <div className="center-data">
                      <div className="center-detail">
                        <strong>{centerItem.detail}</strong>
                      </div>
                      <div className="d-flex mb-1">
                        <span className="center-type">Filières :</span>
                        <span className="mx-2">{centerItem.type}</span>
                      </div>
                      <div style={{ fontStyle: "italic", color: "#3f8600", fontSize: "0.9rem" }}>
                        🌱 {getIncitativeMessage(centerItem.type)}
                      </div>
                      <div className="center-stars mt-2">
                        <ReactStars
                            count={5}
                            size={24}
                            value={centerItem.starNum}
                            edit={false}
                            activeColor="#ffd700"
                        />
                      </div>
                    </div>
                  </div>
                    ))}

                <div className="pagination">
                  <span className="mx-2">
                    <SlArrowLeft onClick={prevPage} />
                  </span>
                  <span className="mx-2">
                    {currentPage} / {totalPage}
                  </span>
                  <span className="mx-2">
                    <SlArrowRight onClick={nextPage} />
                  </span>
                </div>

                </div>
            </div>
            <div className="col-xl-6 col-md-6 col-sm-12 border map-content d-flex flex-column">
                  <div className="upSide"></div>
                  <div className="downSide">
                  <h4>Le parcours territorial de votre pays est en cours ...</h4>
                  </div>      
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default DefaultCountry